import { useState, useEffect } from 'react';
import * as React from 'react';
import { toast } from 'react-toastify';
// @mui
import {
  Button,
  MenuItem,
  TextField,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Select,
  OutlinedInput,
  Radio,
  RadioGroup,
  FormControl,
  Autocomplete,
  FormControlLabel,
  Backdrop,
  CircularProgress,
  Typography,
  Switch,
  Stack,
} from '@mui/material';
import CheckCircleOutline from '@mui/icons-material/CheckCircleOutline';
import Services from 'src/services/Services';
import { useLocalization } from 'src/context/LocalizationContext';
import api from 'src/services/BaseService';

function AddEditUserModal({
  userID,
  isUserDialogOpen,
  actionType,
  setUserDialogOpen,
  MenuProps,
}) {
  const { language } = useLocalization();
  const [token, setToken] = useState('');
  const [buttonLoading, setButtonLoading] = useState(false);
  const [resetLoading, setResetLoading] = useState(false);
  const [isAutocompleteVisible, setIsAutocompleteVisible] = useState(true);
  const [selectedUserType, setSelectedUserType] = useState('user');
  const [name, setName] = useState('');
  const [lastname, setLastname] = useState('');
  const [email, setEmail] = useState('');
  const [phone, setPhone] = useState('');
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [status, setStatus] = useState(false);
  const [frontAuth, setFrontAuth] = useState([]);
  const [locations, setLocations] = useState([]);
  const [selectedRoles, setSelectedRoles] = useState([]);
  const [firstResponsibleOffice, setFirstResponsibleOffice] = useState(null);
  const [selectedLocations, setSelectedLocations] = useState([]);
  const [statusChanged, setStatusChanged] = useState(false);
  const [isLoading, setIsLoading] = useState(true);
  const parsedUser = JSON.parse(localStorage.getItem('user'));
  const [updateFrontAuth, setUpdateFrontAuth] = useState(true);
  const [lockerSwitch, setLockerSwitch] = useState(false); // Yeni switch state'i

  // Şifre gönderme modal state'leri
  const [modalStep, setModalStep] = useState(0);
  const [selectedUser, setSelectedUser] = useState({ id: null, name: '', phone: '' });
  const [newPhoneNumber, setNewPhoneNumber] = useState('');
  const [modalError, setModalError] = useState('');

  const [roles, setRoles] = useState([
    {
      title: language.commons.labels.operation,
      value: 'operations',
    },
    {
      title: language.commons.labels.manager,
      value: 'manager',
    },
    {
      title: language.commons.labels.technical_support,
      value: 'technical-support-staff',
    },
    {
      title: language.commons.labels.technical_manager,
      value: 'technical-support-manager',
    },
  ]);

  const options = locations?.map((option) => {
    const firstLetter = option.title[0].toUpperCase();
    return {
      firstLetter: /[0-9]/.test(firstLetter) ? '0-9' : firstLetter,
      ...option,
    };
  });

  const handleLockerSwitchChange = (e) => {
    const checked = e.target.checked;
    setLockerSwitch(checked);
    if (checked) {
      if (!selectedRoles.includes('can-view-lockers')) {
        setSelectedRoles((prev) => [...prev, 'can-view-lockers']);
      }
    } else {
      setSelectedRoles((prev) =>
        prev.filter((role) => role !== 'can-view-lockers')
      );
    }
  };

  const handleSubmit = () => {
    let allowedPoints = [];
    let body_data = {};
    console.log('selectedRoles: ', selectedRoles);
    if (actionType === 'new') {
      // yeni kullanıcı
      if (isAutocompleteVisible) {
        if (
          firstResponsibleOffice &&
          name?.length > 0 &&
          lastname?.length > 0 &&
          username?.length > 0 &&
          phone?.length >= 10 &&
          email?.length > 0 &&
          password?.length > 0 &&
          selectedRoles?.length > 0
        ) {
          allowedPoints.push({
            id: firstResponsibleOffice.id,
            isFirstResponsible: true,
          });
          if (selectedLocations?.length > 0) {
            for (let i = 0; i < selectedLocations?.length; i++) {
              allowedPoints.push({
                id: selectedLocations[i].id,
                isFirstResponsible: false,
              });
            }
          }

          body_data = {
            type: selectedUserType,
            name: name,
            lastname: lastname,
            email: email,
            phone: phone,
            username: username,
            password: password,
            allowedPoints: allowedPoints,
            isAdministrator:
              selectedRoles.includes('manager') ||
              selectedRoles.includes('EP') ||
              selectedRoles.includes('EPS'),
            frontAuth:
              selectedUserType === 'esnaf' ? ['operations'] : selectedRoles,
          };
        } else {
          toast.error('Zorunlu alanları doldurunuz.');
          setIsLoading(false);
          setButtonLoading(false);
          return;
        }
      } else {
        // user ve manager
        body_data = {
          type: selectedUserType,
          name: name,
          lastname: lastname,
          email: email,
          phone: phone,
          username: username,
          password: password,
          allowedPoints: [],
          isAdministrator:
            selectedRoles.includes('manager') ||
            selectedRoles.includes('EP') ||
            selectedRoles.includes('EPS'),
          frontAuth: selectedRoles,
        };
      }
      console.log('body_data: ', body_data);
      Services.CreateEmployee(token, body_data)
        .then((res) => {
          console.log(res.data);
          if (res.data.status) {
            toast.success('Kullanıcı oluşturuldu.');
            setTimeout(() => {
              window.location.reload(true);
            }, 2000);
          } else {

            if (res.data.message.includes("Username must be unique")) {
              toast.error('Kullanıcı adı zaten mevcut, lütfen başka bir kullanıcı adı deneyin');
            }
            else {
              toast.error('Kullanıcı oluşturulurken bir hata oluştu.');
            }

          }
        })
        .catch((err) => {
          toast.error('Kullanıcı oluşturulurken bir hata oluştu.');
        })
        .finally(() => setButtonLoading(false));
    } else {
      // düzenleme
      if (isAutocompleteVisible) {
        if (
          firstResponsibleOffice &&
          name?.length > 0 &&
          lastname?.length > 0 &&
          username?.length > 0 &&
          phone?.length >= 10 &&
          email?.length > 0 &&
          password?.length > 0 &&
          selectedRoles?.length > 0
        ) {
          allowedPoints.push({
            id: firstResponsibleOffice.id,
            isFirstResponsible: true,
          });
          if (selectedLocations?.length > 0) {
            for (let i = 0; i < selectedLocations?.length; i++) {
              allowedPoints.push({
                id: selectedLocations[i].id,
                isFirstResponsible: false,
              });
            }
          }

          body_data = {
            userID: userID,
            type: selectedUserType,
            name: name,
            lastname: lastname,
            email: email,
            phone: phone,
            username: username,
            password: password,
            allowedPoints: allowedPoints,
            isAdministrator:
              selectedRoles.includes('manager') ||
              selectedRoles.includes('EP') ||
              selectedRoles.includes('EPS'),
            frontAuth:
              selectedUserType === 'esnaf' ? ['operations'] : selectedRoles,
            status: status,
          };
        } else {
          toast.error('Zorunlu alanları doldurunuz.');
          setButtonLoading(false);
          return;
        }
      } else {
        // user ve manager
        body_data = {
          userID: userID,
          type: selectedUserType,
          name: name,
          lastname: lastname,
          email: email,
          phone: phone,
          username: username,
          password: password,
          allowedPoints: [],
          isAdministrator:
            selectedRoles.includes('manager') ||
            selectedRoles.includes('EP') ||
            selectedRoles.includes('EPS'),
          frontAuth: selectedRoles,
          status: status,
        };
      }
      Services.UpdateProfile(token, body_data)
        .then((res) => {
          if (res.data.status) {
            userSetStatus();
          } else {
            toast.error('Kullanıcı bilgileri düzenlenirken bir hata oluştu.');
          }
        })
        .catch((err) => {
          toast.error('Kullanıcı bilgileri düzenlenirken bir hata oluştu.');
        })
        .finally(() => setButtonLoading(false));
    }
  };

  const handleModalClose = () => {
    setModalStep(0);
    setSelectedUser({ id: null, name: '', phone: '' });
    setNewPhoneNumber('');
    setResetLoading(false);
    setModalError('');
  };

  const handleResetPassword = () => {
    setSelectedUser({ id: userID, name: name, phone: phone });
    setNewPhoneNumber(phone || '');
    setModalStep(1);
  };

  const handleSendSms = async () => {
    setResetLoading(true);
    setModalError('');
    try {
      const response = await api.post('flow/reset-password-and-send-sms', {
        userID: userID,
      });
      if (response.data.status) {
        setModalStep(3);
      } else {
        setModalError(response.data.message || 'SMS gönderilirken bir hata oluştu.');
      }
    } catch (error) {
      setModalError(error.message || 'Sunucu hatası. SMS gönderilemedi.');
    } finally {
      setResetLoading(false);
    }
  };

  const handleUpdateAndSendSms = async () => {
    if (newPhoneNumber.length < 10) {
      setModalError('Lütfen geçerli bir telefon numarası girin.');
      return;
    }

    setResetLoading(true);
    setModalError('');

    try {
      const userResponse = await Services.GetUser(token, userID);
      if (!userResponse.data.status) {
        throw new Error('Kullanıcı verileri çekilemedi.');
      }

      const userData = userResponse.data.result;
      const body_data = {
        ...userData,
        userID: userID,
        phone: newPhoneNumber,
        password: userData.password || undefined
      };

      const updateResponse = await Services.UpdateProfile(token, body_data);
      if (updateResponse.data.status) {
        await handleSendSms();
      } else {
        throw new Error(updateResponse.data.message || 'Profil güncellenemedi.');
      }

    } catch (error) {
      setModalError(error.message);
      setResetLoading(false);
    }
  };

  const handleCloseUserDialog = () => {
    setName('');
    setLastname('');
    setUsername('');
    setEmail('');
    setPhone('');
    setPassword('');
    setSelectedRoles([]);
    setSelectedLocations([]);
    setFirstResponsibleOffice(null);
    setSelectedUserType('user');
    setUserDialogOpen(false);
  };

  const generateRandomPassword = () => {
    const length = 6;
    const charset = '0123456789';
    let password = '';
    for (let i = 0; i < length; i++) {
      const randomIndex = Math.floor(Math.random() * charset.length);
      password += charset[randomIndex];
    }
    setIsLoading(false)
    setPassword(password);
  };

  const userSetStatus = () => {
    if (status === false) {
      Services.UserSetPassive(token, userID)
        .then((res) => {
          if (res.data.status) {
            toast.success('Kullanıcı bilgileri düzenlendi.');
            setTimeout(() => {
              window.location.reload(true);
            }, 2000);
          } else {
            toast.error('Kullanıcı bilgileri düzenlenirken bir hata oluştu.');
            setTimeout(() => {
              window.location.reload(true);
            }, 2000);
          }
        })
        .catch((err) => { });
    } else {
      Services.UserSetActive(token, userID)
        .then((res) => {
          if (res.data.status) {
            toast.success('Kullanıcı bilgileri düzenlendi.');
            setTimeout(() => {
              window.location.reload(true);
            }, 2000);
          } else {
            toast.error('Kullanıcı bilgileri düzenlenirken bir hata oluştu.');
            setTimeout(() => {
              window.location.reload(true);
            }, 2000);
          }
        })
        .catch((err) => { });
    }
  };

  useEffect(() => {
    if (selectedUserType === 'admin' && actionType === 'edit') {
      setSelectedRoles((prevSelectedRoles) => {
        return roles
          .filter((role) => frontAuth.includes(role.value))
          .map((role) => role.value);
      });
    }
  }, [roles]);

  useEffect(() => {
    if (!isUserDialogOpen) {
      return;
    }

    if (actionType === 'edit') {
      setIsLoading(true);
    }

    setToken(parsedUser.token);
    Services.GetPoints(parsedUser.token)
      .then((res) => {
        const points = res.data.result?.map((item) => ({
          title: item.title,
          id: item.id,
        }));
        setLocations(points);

        if (actionType === 'edit') {
          Services.GetUser(parsedUser.token, userID)
            .then((response) => {
              const user = response.data.result;
              const selectedRolesFromFrontAuth = roles
                .filter((role) => user?.frontAuth?.includes(role.value))
                .map((role) => role.value);

              const _firstResponsibleOffice = Array.isArray(user?.allowedPoints)
                ? user?.allowedPoints?.find(
                  (point) => point?.firstResponsible === true
                )
                : null;

              const _selectedLocations = Array.isArray(user?.allowedPoints)
                ? user?.allowedPoints
                  ?.filter((point) => point?.firstResponsible === false)
                  .map((point) => point)
                : [];

              setStatus(user.status === '1' ? true : false);
              setSelectedUserType(user.type);
              setName(user.name);
              setLastname(user.lastname);
              setUsername(user.username);
              setFrontAuth(user.frontAuth ? user.frontAuth : []);
              setEmail(user.email);
              setPhone(user.phone);
              setPassword(user.password);
              setSelectedRoles(selectedRolesFromFrontAuth);
              setFirstResponsibleOffice(_firstResponsibleOffice);
              setSelectedLocations(_selectedLocations);

              // Edit modunda, frontAuth'da "can-view-lockers" varsa switch true olsun.
              if (
                user.frontAuth &&
                user.frontAuth.includes('can-view-lockers')
              ) {
                setLockerSwitch(true);
              } else {
                setLockerSwitch(false);
              }

              if (user.type === 'admin') {
                setRoles((prevRoles) => {
                  const newRoles = [
                    ...prevRoles.filter((role) => role.value !== 'operations'),
                  ];
                  const additionalRoles = [
                    { title: 'EP', value: 'EP' },
                    { title: 'EPS', value: 'EPS' },
                  ];
                  additionalRoles.forEach((role) => {
                    if (
                      !newRoles.some(
                        (existingRole) => existingRole.value === role.value
                      )
                    ) {
                      newRoles.push(role);
                    }
                  });

                  return newRoles;
                });

                setUpdateFrontAuth(true);
              }
            })
            .catch((error) => { })
            .finally(() => {
              setIsLoading(false);
            });
        } else {
          setSelectedUserType('user');
          setName('');
          setLastname('');
          setUsername('');
          setEmail('');
          setPhone('');
          generateRandomPassword();
          setSelectedRoles([]);
          setSelectedLocations([]);
          setFirstResponsibleOffice(null);
          setLockerSwitch(false);
        }
      })
      .catch((err) => {
        console.log(err);
        setLocations([]);
        setSelectedUserType('user');
        setName('');
        setLastname('');
        setUsername('');
        setEmail('');
        setPhone('');
        setPassword('');
        setSelectedRoles([]);
        setSelectedLocations([]);
        setFirstResponsibleOffice(null);
      });
  }, [isUserDialogOpen]);

  // RadioGroup onChange güncellemesi: tür değiştiğinde can-view-lockers'ı kaldır.
  const handleUserTypeChange = (e) => {
    const newSelectedType = e.target.value;
    setSelectedUserType(newSelectedType);

    // Tür değiştiğinde dolap takip sistemini kapat ve ilgili rolü listeden çıkar
    setLockerSwitch(false);
    setSelectedRoles((prev) =>
      prev.filter((role) => role !== 'can-view-lockers')
    );

    if (newSelectedType === 'admin') {
      setRoles((prevRoles) => {
        const newRoles = [
          ...prevRoles.filter((role) => role.value !== 'operations'),
        ];
        const additionalRoles = [
          { title: 'EP', value: 'EP' },
          { title: 'EPS', value: 'EPS' },
        ];
        additionalRoles.forEach((role) => {
          if (
            !newRoles.some((existingRole) => existingRole.value === role.value)
          ) {
            newRoles.push(role);
          }
        });
        return newRoles;
      });
    } else {
      setRoles((prevRoles) => {
        const roleExists = prevRoles.some(
          (role) => role.value === 'operations'
        );
        return roleExists
          ? prevRoles.filter(
            (role) => !['EP', 'EPS', 'EPX'].includes(role.value)
          )
          : [
            ...prevRoles.filter(
              (role) => !['EP', 'EPS', 'EPX'].includes(role.value)
            ),
            { title: 'Operasyon', value: 'operations' },
          ];
      });
    }

    if (newSelectedType === 'esnaf') {
      setSelectedRoles(['operations']);
    } else {
      setSelectedRoles([]);
    }
  };

  const handleStatusChange = () => {
    setStatus(!status);
    setStatusChanged(!statusChanged);
  };

  return (
    <>
    <Dialog open={isUserDialogOpen}>
      <DialogTitle>
        {language.commons.roles.user}{' '}
        {actionType === 'new' ? language.commons.add : language.commons.edit}
      </DialogTitle>
      <DialogContent>
        <Stack
          sx={{
            width: '100%',
            direction: 'row',
            alignItems: 'center',
            display: 'flex',
            flexDirection: 'row',
            mb: 2,
          }}
        >
          <FormControl component="fieldset" sx={{ width: '100%' }}>
            <RadioGroup
              style={{
                display: 'flex',
                flexDirection: 'row',
                width: '100%',
              }}
              aria-label="user-type"
              name="user-type"
              value={selectedUserType}
              onChange={handleUserTypeChange}
            >
              <FormControlLabel
                value="user"
                control={<Radio />}
                label={language.commons.roles.user}
              />
              <FormControlLabel
                value="esnaf"
                control={<Radio />}
                label={language.commons.roles.tradesmen}
              />

              {parsedUser.type === 'highadmin' && (
                <>
                  <FormControlLabel
                    value="admin"
                    control={<Radio />}
                    label={language.commons.roles.admin}
                  />
                  <FormControlLabel
                    value="highadmin"
                    control={<Radio />}
                    label={language.commons.roles.high_admin}
                  />
                </>
              )}
            </RadioGroup>
          </FormControl>
          {actionType === 'edit' && (
            <div
              style={{
                flexDirection: 'row',
                display: 'flex',
                justifyContent: 'flex-end',
                alignItems: 'center',
                width: '100%',
              }}
            >
              <Typography
                sx={{
                  fontWeight: '500',
                  fontSize: '14px',
                  color: '#6B7280',
                  fontFamily: 'Inter',
                  marginRight: '5px',
                }}
              >
                {language.commons.labels.user_status}:
              </Typography>
              {status ? (
                <Typography
                  sx={{
                    fontWeight: '500',
                    fontSize: '14px',
                    color: '#079455',
                    fontFamily: 'Inter',
                  }}
                >
                  {language.commons.labels.active}
                </Typography>
              ) : (
                <Typography
                  sx={{
                    fontWeight: '500',
                    fontSize: '14px',
                    color: '#D92D20',
                    fontFamily: 'Inter',
                  }}
                >
                  {language.commons.labels.passive}
                </Typography>
              )}

              <Switch
                checked={status}
                onChange={handleStatusChange}
                name="status"
                color="primary"
                inputProps={{ 'aria-label': 'primary checkbox' }}
              />
            </div>
          )}
        </Stack>

        <Select
          fullWidth
          label={language.commons.labels.auth_levels + ' *'}
          placeholder={language.commons.labels.auth_levels + ' *'}
          displayEmpty
          multiple
          disabled={selectedUserType === 'esnaf'}
          value={selectedRoles}
          onChange={(event) => {
            setSelectedRoles(event.target.value);
          }}
          input={<OutlinedInput />}
          sx={{ mb: 2 }}
          renderValue={(selected) => {
            const displayedRoles = selected?.filter(
              (value) => value !== 'can-view-lockers'
            );
            if (displayedRoles.length === 0) {
              return <em>{language.commons.labels.auth_levels + ' *'}</em>;
            }
            return displayedRoles
              .map(
                (value) => roles?.find((role) => role.value === value)?.title
              )
              .join(', ');
          }}
          MenuProps={MenuProps}
          inputProps={{ 'aria-label': 'Without label' }}
        >
          {roles?.map((x, index) => (
            <MenuItem key={index} value={x.value}>
              {x.title}
            </MenuItem>
          ))}
        </Select>

        <TextField
          label="Ad *"
          autoComplete="off"
          fullWidth
          value={name}
          onChange={(e) => setName(e.target.value)}
          sx={{ my: 2 }}
        />
        <TextField
          label="Soyad *"
          autoComplete="off"
          fullWidth
          value={lastname}
          onChange={(e) => setLastname(e.target.value)}
          sx={{ mb: 2 }}
        />
        <TextField
          label="E-posta *"
          autoComplete="off"
          fullWidth
          value={email}
          onChange={
            actionType === 'new'
              ? (e) => {
                setEmail(e.target.value);
                setUsername(e.target.value);
              }
              : (e) => setEmail(e.target.value)
          }
          sx={{ mb: 2 }}
        />
        <TextField
          label={language.commons.labels.username + '*'}
          autoComplete="off"
          fullWidth
          value={username}
          onChange={(e) => setUsername(e.target.value)}
          sx={{ mb: 2 }}
        />
        <TextField
          label={language.commons.labels.phone + '*'}
          autoComplete="off"
          fullWidth
          value={phone}
          type="number"
          onChange={(e) => setPhone(e.target.value)}
          sx={{ mb: 2 }}
        />
        {actionType === 'edit' ? (
          <Button
            disabled={resetLoading}
            variant="contained"
            fullWidth
            onClick={handleResetPassword}
            sx={{width: '100%', maxWidth: '200px', mb: 2, py: '11px' }}
          >
            {resetLoading ? (
              <CircularProgress size={24} />
            ) : (
              'Yeni Şifre Gönder'
            )}
          </Button>
        ) : (
          <TextField
            label={language.commons.labels.password + '*'}
            autoComplete="off"
            fullWidth
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            sx={{ mb: 2 }}
          />
        )}
        <Backdrop
          sx={{ color: '#fff', zIndex: 2, height: '100%' }}
          open={isLoading}
        >
          <CircularProgress color="inherit" />
        </Backdrop>
        {isAutocompleteVisible && (
          <>
            <Autocomplete
              id="grouped-demo"
              fullWidth
              value={firstResponsibleOffice}
              sx={{ mb: 2 }}
              options={options?.sort(
                (a, b) => -b.firstLetter.localeCompare(a.firstLetter)
              )}
              groupBy={(option) => option.firstLetter}
              getOptionLabel={(option) => option.title}
              onChange={(event, newValue) => {
                setFirstResponsibleOffice(newValue);
              }}
              renderInput={(params) => (
                <TextField
                  {...params}
                  label={language.commons.labels.allowedPoints + '*'}
                  placeholder={language.commons.labels.allowedPoints + '*'}
                />
              )}
            />
            <Autocomplete
              id="grouped-demo2"
              fullWidth
              multiple
              value={selectedLocations}
              disabled={
                firstResponsibleOffice === null ||
                firstResponsibleOffice === '' ||
                firstResponsibleOffice?.length === 0
              }
              options={options?.filter(
                (option) =>
                  !selectedLocations.map((loc) => loc.id).includes(option.id) &&
                  option.id !== firstResponsibleOffice?.id
              )}
              groupBy={(option) => option.firstLetter}
              getOptionLabel={(option) => option.title}
              onChange={(event, newValue) => {
                setSelectedLocations(newValue);
              }}
              renderInput={(params) => (
                <TextField
                  {...params}
                  label={language.components.AddEditUserModal.auth_units}
                  placeholder={language.components.AddEditUserModal.auth_units}
                />
              )}
            />
          </>
        )}

        {/* Dolap Takip Sistemi Switch: sadece admin veya user için */}
        {(selectedUserType === 'admin' || selectedUserType === 'user') && (
          <Stack direction="row" alignItems="center" spacing={1} sx={{ mt: 2 }}>
            <Typography>Dolap Takip Sistemi</Typography>
            <Switch
              checked={lockerSwitch}
              onChange={handleLockerSwitchChange}
              name="lockerSwitch"
              color="primary"
            />
          </Stack>
        )}
      </DialogContent>
      <DialogActions>
        <Button
          disabled={buttonLoading}
          variant="contained"
          onClick={handleSubmit}
        >
          <>
            {buttonLoading
              ? language.components.AddEditUserModal.process_being
              : actionType === 'edit'
                ? language.commons.finish_edit
                : language.commons.add}
          </>
        </Button>
        <Button onClick={handleCloseUserDialog}>{language.commons.cancel}</Button>
      </DialogActions>
    </Dialog>

    {/* --- ŞİFRE GÖNDERME MODALI --- */}
    <Dialog open={modalStep > 0} onClose={handleModalClose} maxWidth="xs" fullWidth>
      {modalStep === 1 && (
        <>
          <DialogTitle>Yeni Şifre Gönderme Talebi</DialogTitle>
          <DialogContent>
            <Typography variant="body1" align="start" sx={{ mb: 1 }}>
              Telefon numarası <strong>{phone}</strong> olan kullanıcıya SMS ile <strong>yeni şifre gönderme</strong> işlemini <strong>onaylıyor musunuz?</strong>
            </Typography>
            {modalError && <Typography color="error" align="start">{modalError}</Typography>}
          </DialogContent>
          <DialogActions sx={{ flexDirection: 'column', py: 1, px: 2, gap: 1 }}>
            <Button onClick={handleSendSms} variant="contained" color="primary" fullWidth disabled={resetLoading} sx={{py: '11px'}}>
              {resetLoading ? <CircularProgress size={24} /> : 'İşleme Devam Et'}
            </Button>
            <Button onClick={() => setModalStep(2)} variant="outlined" fullWidth sx={{py: '11px'}}>
              Telefon Numarasını Güncelle
            </Button>
            <Button onClick={handleModalClose} variant="outlined" sx={{borderColor: '#000', color: '#000', py: '11px'}} fullWidth>
              Vazgeç
            </Button>
          </DialogActions>
        </>
      )}
      {/* --- 2. Adım: Telefon Güncelleme Ekranı --- */}
      {modalStep === 2 && (
        <>
          <DialogTitle>Yeni Şifre Gönderme Talebi</DialogTitle>
          <DialogContent>
            <Typography variant="body1" align="start" sx={{ mb: 1}}>
              Telefon numarası <strong>{phone}</strong> olan kullanıcıya SMS ile <strong>yeni şifre gönderme</strong> işlemini <strong>onaylıyor musunuz?</strong>
            </Typography>
            <TextField
              fullWidth
              label="Yeni Telefon Numarası"
              value={newPhoneNumber}
              onChange={(e) => setNewPhoneNumber(e.target.value)}
              placeholder="+90 555 555 55 55"
              margin="normal"
            />
            {modalError && <Typography color="error" align="center" sx={{ mt: 1 }}>{modalError}</Typography>}
          </DialogContent>
          <DialogActions sx={{ flexDirection: 'column', py: 1, px: 2, gap: 1 }}>
            <Button onClick={handleUpdateAndSendSms} variant="contained" color="primary" fullWidth disabled={resetLoading} sx={{fontSize: 13, py: '11px' }}>
              {resetLoading ? <CircularProgress size={24} /> : 'Telefon Numarasını Güncelle ve Gönder'}
            </Button>
            <Button onClick={handleModalClose} variant="outlined" sx={{borderColor: '#000', color: '#000', fontSize: 13, py: '11px'}} fullWidth>
              Vazgeç
            </Button>
          </DialogActions>
        </>
      )}
      {/* --- 3. Adım: Başarı Ekranı --- */}
      {modalStep === 3 && (
        <>
          <DialogTitle align="center">Yeni Şifre Başarıyla Gönderildi</DialogTitle>
          <DialogContent sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 2 }}>
            <CheckCircleOutline sx={{ fontSize: 60, color: 'green' }} />
            <Typography variant="body1" align="center">
              Telefon numarası <strong>{newPhoneNumber || phone}</strong> olan kullanıcıya SMS ile şifre gönderme işlemi başarıyla sağlanmıştır.
            </Typography>
          </DialogContent>
          <DialogActions sx={{ p: 2 }}>
            <Button onClick={handleModalClose} variant="contained" fullWidth>
              Tamam
            </Button>
          </DialogActions>
        </>
      )}
    </Dialog>
    </>
  );
}

export default AddEditUserModal;
